export const authActionTypes = {
  UPDATE_AUTH_DATA: 'UPDATE_AUTH_DATA',
  CLEAR_AUTH_DATA: 'CLEAR_AUTH_DATA',
  LOGIN: 'LOGIN',
  CHANGE_STATUS_USER: 'CHANGE_STATUS_USER',
};
